import React from "react";
import ReportsView from "./ReportsView";

export default function AdminReports() {
    return <ReportsView fetchUrl="/reports/all" />;
}
